module.exports = __webpack_public_path__ + "assets/banner-arrangement29867c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner/banner-arrangement.jpg
// module id = 230
// module chunks = 23